import { Component, h, JSX, Host } from '@stencil/core';
import { MESSAGES } from 'src/components/constants';
import { getCountrySettings } from 'src/utils/getCountrySettings';
import { store } from 'src/utils/store';

@Component({
    tag: 'belimo-privacy-policy',
    shadow: false,
})
export class BelimoPrivacyPolicy {
    private createUrl(): string {
        const data  = getCountrySettings(store.state.config, store.state.currentCountry, store.state.currentRegion);
        if (data === null) {
            return 'https://belimo.com';
        }
        const { privacy, domain } = data;
        return privacy.substring(0 ,1) === 'h' ? privacy : `${domain}${privacy}`.replace('%locale%', store.state.currentLocale);
    }

    public render(): JSX.Element {
        return (<Host>
            <a href={this.createUrl()} target="_blank">
                <belimo-i18n messageId={MESSAGES.REQUEST_PRODUCT_FORM_PRIVACY_POLICY}/>
            </a>
        </Host>)
    }
}
